import * as  React from 'react';
import { Glyphicon } from 'react-bootstrap';
import Lightbox from 'react-image-lightbox';
import { ColumnsCount, Device } from './types';
import getDimensions from './getDimensions';
import 'react-image-lightbox/style.css';
import './index.css';

interface GalleryProps {
    imageTitle: string;
    images: Array<string>;
    previews: Array<string>;
    photoIndex: number;
    isOpen: boolean;
    closeGallery: () => void;
    onMovePrevRequest: () => void;
    onMoveNextRequest: () => void;
    deleteFile: (photoIndex: number) => void;
    downloadFile: (photoIndex: number) => void;
    nCols: ColumnsCount;

};

class Gallery extends React.Component<GalleryProps> {
  constructor(props: GalleryProps) {
    super(props);
    this.deleteFile = this.deleteFile.bind(this);
    this.downloadFile = this.downloadFile.bind(this);
  }

  render() {
    const {
      imageTitle,
      images,
      previews,
      photoIndex,
      isOpen,
      closeGallery,
      onMovePrevRequest,
      onMoveNextRequest,
      nCols
    } = this.props;

    const styles = updateStyles(nCols);
    const { toolbars, title, buttons } = styles;
    const { downloadButton, deleteButton, backButton, closeButton, buttonSize } = buttons;
    return (
      (isOpen) ? (
        <div>
          <Lightbox
            mainSrc={images[photoIndex]}
            mainSrcThumbnail={previews[photoIndex]}
            nextSrc={images[(photoIndex + 1) % images.length]}
            prevSrc={images[(photoIndex + images.length - 1) % images.length]}
            onCloseRequest={closeGallery}
            onMovePrevRequest={onMovePrevRequest}
            onMoveNextRequest={onMoveNextRequest}
          />
          <div className="galleryOverlay top" style={toolbars}>
          { (nCols === 1) ?
            <button onClick={closeGallery} className="galleryButton top left" style={buttonSize}>
              <Glyphicon glyph="menu-left" className="galleryButton" style={backButton} />
            </button>
          :
            <button className="galleryButton bottom right" onClick={closeGallery} style={buttonSize}>
              <Glyphicon glyph="remove" className="galleryButton" style={closeButton} />
            </button>
          }
            <p className="GalleryTitle" style={title}>{imageTitle}</p>
          </div>
          <div className="galleryOverlay bottom" style={toolbars}>
            <span onClick={this.deleteFile} className="galleryButton bottom right" style={buttonSize}>
              <Glyphicon glyph="trash" className="galleryButton" style={deleteButton} />
            </span>
            <span onClick={this.downloadFile} className="galleryButton bottom left" style={buttonSize}>
                <Glyphicon glyph="download-alt" className="galleryButton" style={downloadButton} />
            </span>
          </div>
        </div>
      ) : null
    );
  }

  deleteFile() {
    this.props.deleteFile(this.props.photoIndex);
  }

  downloadFile() {
    this.props.downloadFile(this.props.photoIndex);
  }

}

const updateStyles = (nCols: ColumnsCount): any => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    let device : Device = {FormFactor: 'desktop', position: 'horizontal'};
;

    if (height > width)
        device.position = 'vertical';

    switch(nCols) {
        case 1: {
            device.FormFactor = 'mobile';
            break;
        }
        case 2: {
            device.FormFactor = 'tablet';
            break;
        }
        case 3: {
            device.FormFactor = 'desktop';
            break;
        }
    }
    return getDimensions(device);
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/fileeditor/Gallery.tsx